import {createFileRoute} from '@tanstack/react-router';
import {AuthInvitePage} from '@/features/auth';

interface AuthInviteSearch {
  code?: string;
  accessToken?: string;
  staffId?: string;
}

export const Route = createFileRoute('/_auth/auth/invite')({
  component: () => <AuthInvitePage />,
  validateSearch: (search: AuthInviteSearch) => {
    return search;
  },
});
